module.exports = __webpack_public_path__ + "school/img/catalog.dc848036.png";